module.exports = __webpack_public_path__ + "static/media/search.ee94de36.svg";